import { render, staticRenderFns } from "./MultimediaItem.vue?vue&type=template&id=2778426f&scoped=true"
import script from "./MultimediaItem.vue?vue&type=script&lang=js"
export * from "./MultimediaItem.vue?vue&type=script&lang=js"
import style0 from "./MultimediaItem.vue?vue&type=style&index=0&id=2778426f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2778426f",
  null
  
)

export default component.exports